import PropTypes from 'prop-types'
import styled from 'styled-components'

const VideoResponsiveContainer = styled.div`
  padding-top: 56.25%;
  position: ${({ position }) => position || 'relative'};
  height: 0;
  iframe,
  object,
  video {
    border-radius: ${({ borderRadius }) => (borderRadius ? `${borderRadius}px` : '0px')};
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    background-color: #282c34;
  }
  // THIS IS FOR SOME MOBILES IN LANDSCASCAPE ON HALF TABLETS
  @media screen and (min-width:320px) and (max-width:813px) and (max-height:500px) and (orientation:landscape) {
    padding-top: ${({ isLesson }) => (isLesson ? 'calc(100vh - 62px);' : '56.25%;')};
    iframe, video, object {
      height: ${({ isLesson }) => (isLesson ? 'calc(100vh - 62px);' : '100%;')};
    }
  }
`

VideoResponsiveContainer.displayName = 'VideoResponsive'

function VideoIframe({
  src, element, borderRadius, isLesson, position, ...otherProps
}) {
  return (
    <VideoResponsiveContainer className="vimeo-container" borderRadius={borderRadius} position={position} isLesson>
      <iframe
        title={src}
        ref={element}
        src={src}
        frameBorder="0"
        {...otherProps}
        allowFullScreen
        allow="autoplay; encrypted-media"
        loading="lazy"
        data-cy="vimeo-player"
      />
    </VideoResponsiveContainer>
  )
}

/**
 * `Video-responsive.js`  exports two components: *VideoYoutube* and *VideoIframe*.
 *
 * **Note:** *VideoYoutube* uses the prop **id** as the source of the video,
 *  while *VideoIframe* receives the prop **src**
 * @visibleName Video
 */
function VideoYoutube({
  id,
  autoplay,
  mute,
  start,
  loop,
  controls,
  showInfo,
  playlist,
  isLesson,
  ...otherProps
}) {
  return (
    <VideoResponsiveContainer isLesson={isLesson}>
      <iframe
        title={id}
        src={`https://www.youtube.com/embed/${id}?version=3&start=${start}&autoplay=${autoplay}&mute=${mute}&controls=${controls}&loop=${loop}&playlist=${playlist}`}
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
        loading="lazy"
        {...otherProps}
      />
    </VideoResponsiveContainer>
  )
}

VideoYoutube.defaultProps = {
  autoplay: 0,
  mute: 0,
  t: 0,
  controls: 1,
  loop: 0,
  showInfo: 0,
}

VideoYoutube.propTypes = {
  /** Source of the video */
  id: PropTypes.string.isRequired,
}

export { VideoYoutube, VideoIframe, VideoResponsiveContainer }

export default VideoIframe
